import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  // for generating csv template
  function blobCSV(arrData: Array<Array<string | number>>): Blob {
    // let csv = '';
    // // define separator (, or ;)
    // let separator = ',';
    // const hasComma = _filter(
    //     _flatten(arrData),
    //     (item) => item.includes(',')
    // ).length;
    // if (hasComma) {
    //     separator = ';';
    // }

    // for (let i = 0; i < arrData.length; i++) {
    //     const line = arrData[i].map(item => (
    //         // `"${_isString(item) ? item.replace('"', '""') : item}"`
    //         item
    //     )).join(separator);
    //     csv += `${line}\r\n`;
    // }
    // return new Blob([csv], { type: 'text/csv;charset=utf-8;' });

    let csv = "";

    for (let i = 0; i < arrData.length; i++) {
      const line = arrData[i]
        .map((item) => {
          // `"${_isString(item) ? item.replace('"', '""') : item}"`

          // if data has comma (like the separator)
          if (typeof item === "string" && item.includes(",")) {
            return `"${item}"`;
          }
          return item;
        })
        .join(",");
      csv += `${line}\r\n`;
    }
    return new Blob([csv], { type: "text/csv;charset=utf-8;" });
  }

  return {
    blobCSV,
  };
}
